import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {VouchersService} from '../vouchers.service';
import {baseUrl} from '../../url.model';


@Component({
	selector: 'kt-new-voucher',
	templateUrl: './new-voucher.component.html',
	styleUrls: ['./new-voucher.component.scss']
})
export class NewVoucherComponent implements OnInit {
	@Input() public id;
	color;
	imageEndpoint = baseUrl + 'images/voucherImages';

	editorConfig = {
		editable: true,
		spellcheck: false,
		translate: 'yes',
		height: '10rem',
		minHeight: '5rem',
		placeholder: 'Kérem adja meg a voucher leírást!',
		// toolbar: [
		// 	['bold', 'italic', 'underline'],
		// 	['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
		// ]
		toolbar: [
			['bold', 'italic', 'underline', 'strikeThrough', 'superscript', 'subscript'],
			['fontSize', 'color'],
			['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
			['cut', 'copy', 'delete', 'removeFormat', 'undo', 'redo'],
			['paragraph', 'blockquote', 'removeBlockquote', 'horizontalLine', 'orderedList', 'unorderedList'],
			['link', 'unlink', 'image', 'video']
		]
	};

	form = this.fb.group({
		name: ['', Validators.required],
		description: ['', Validators.required],
		password: ['']
	});

	constructor(private service: VouchersService, public activeModal: NgbActiveModal, private toastr: ToastrService, private fb: FormBuilder) {
	}

	ngOnInit() {
		if (this.id) {
			this.service.getVoucher(this.id).subscribe(resp => {
				this.form.setValue({
					name: resp.name,
					description: resp.description,
					password: resp.password
				});
			});
		}
	}

	save() {
		if (!this.id) {
			this.service.newVoucher(this.form.getRawValue()).subscribe((res) => {
				if (res.status == 200) {
					this.toastr.success('A vouchert sikeresen hozzáadta', '');
					this.activeModal.close(true);
				} else {
					this.toastr.error('Hiba létrehozás közben', 'Hiba');
				}
			}, (error) => {
				this.toastr.error(error.error.message, 'Hiba');
			});
		} else {
			this.service.modifyVoucher(this.id, this.form.getRawValue()).subscribe((res) => {
					if (res.status == 200) {
						this.toastr.success('A vouchert sikeresen frissítette', '');
						this.activeModal.close(true);
					} else {
						this.toastr.error('Hiba történt!', '');
					}
				}, (error => {
					this.toastr.error(error.error.message, 'Hiba');
				})
			);
		}
	}

}
